module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "kpi"
  }, [_c('div', {
    staticClass: "kpi-bar",
    class: _vm.accent
  }), _vm._v(" "), _c('div', {
    staticClass: "label"
  }, [_vm._v(_vm._s(_vm.label))]), _vm._v(" "), _c('div', {
    staticClass: "value"
  }, [_vm._v(_vm._s(_vm.value))])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-loader/node_modules/vue-hot-reload-api").rerender("data-v-612bb1b3", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-612bb1b3"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/dashboard/kpiCard.vue
// module id = 2997
// module chunks = 0